import { useSelector } from 'react-redux'

import { Avatar } from 'app/components'
import Styles from './statusMessage.module.scss'

const getLanguageInfo = ({ widgetData }) => widgetData.widgetInfo.languageInfo

const StatusMessage = ({ messageType, operatorName, operatorAvatar, operatorId }) => {
  const languageInfo = useSelector(getLanguageInfo)

  if (messageType === 'accept_status') {
    return (
      <div className={Styles.status_msg_wrapper}>
        <div className={Styles.operator_avatar_container}>
          <Avatar
            backgroundSize={30}
            avatarInfo={{
              url: operatorAvatar,
              name: operatorName,
            }}
            showTooltip={false}
            operatorId={operatorId}
            withBorder={false}
          />
        </div>

        <p className={Styles.status_text}>
          {operatorName} {languageInfo.texts.acceptConversationWithYou}
        </p>
      </div>
    )
  }

  return (
    <div className={Styles.status_msg_wrapper}>
      <span className={Styles.status_text}>{languageInfo.texts.conversationClosed}</span>
    </div>
  )
}

export default StatusMessage
